const isWithinDate = (startDateValue: string, endDateValue: string) => {
  if (endDateValue) {
    const endDate = new Date(endDateValue);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    if (startDateValue) {
      const startDate = new Date(startDateValue);

      if (startDate < today && endDate > yesterday) {
        return true;
      }
    } else if (endDate > yesterday) {
      return true;
    }
  }

  return false;
};

export default isWithinDate;
